function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

export function replace_all(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}
